module.exports = __webpack_public_path__ + "img/GALLERY-CIAZ-2.8cd51a6b.jpg";